import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Main from '../views/Main.vue'
import Gallery from '../views/Gallery.vue'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/galeria',
      name: 'Gallery',
      component: Gallery
    },
    {
      path: '/administrar',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if(!firebase.auth().currentUser) next()
        else next('/main')
      }
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      beforeEnter: (to, from, next) => {
        if(!firebase.auth().currentUser) next('/administrar')
        else next()
      }
    },
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router